import React from "react";
import Card from "react-bootstrap/Card";

import './Resume.css'

function Resume_Work() {
  return (
    <>
      <Card className={"resume-card"}>
        <h1 className={"resume-card-title"}>Work Experiences</h1> <br></br>
        <div className={"resume-card-contents"}>
          <h4>2024.05 ~ </h4>
          <h5>Warker Chemical Korea</h5>
          <h6>Business System Analyst, IT</h6>
          <p style={{ textAlign: "left" }}>
            <b>Main Responsibilities</b> <br></br>
              In-house software responsible <br></br> <br></br>
            <b>Main Tasks / Achievements</b> <br></br>
            - Analysis of user requirements <br></br>
            - Software architecture / process analysis <br/>
            - SAP error analysis and solution sharing <br />
            - software and security training <br /> 
            - RPA development<br></br> <br></br>
            <b>Achievements and Lessons Learned</b> <br></br>
              SAP Migration project responsible <br></br><br></br>
          </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2022.11 ~ 2024.04</h4>
          <h5>Kyobo DTS</h5>
          <h6>Assistant in Insurance Technology Operations Team 1</h6>
          <p style={{ textAlign: "left" }}>
            <b>Main Responsibilities</b> <br></br>
            Operating systems for Kyobo Life Asset Management Part <br></br> <br></br>
            <b>Main Tasks / Achievements</b> <br></br>
            Carried out operating tasks for SAP accounting real estate system based on SAP ABAP <br></br> <br></br>
            <b>Achievements and Lessons Learned</b> <br></br>
            1. Progressed system improvement tasks to meet the demands of the field (improvement of rental contract and rent-related calculation logic) to enhance user convenience <br></br>
            2. Updated existing system operator manual for IT audit (table design, program / function group design, interface status) <br></br> <br></br>
          </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2022.01 ~ 2022.06</h4>
          <h5>RCI Financial Services Korea</h5>
          <h6>IT Infrastructure Team Intern</h6>
          <p style={{ textAlign: "left" }}>
            <b>Main Responsibilities</b> <br></br>
            Supporting internal IT infrastructure operation and management <br></br> <br></br>
            <b>Main Tasks / Achievements</b> <br></br>
            1. Managed internal business network and business network servers <br></br>
            2. Conducted OA business data analysis <br></br>
            3. Improved OA business processes based on data analysis <br></br> <br></br>

            <b>Achievements and Lessons Learned</b> <br></br>
            1. Documented internal processes <br></br>
            2. Increased efficiency of OA business processes through support for OA business process automation system development <br></br> <br></br>
          </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2020.12 ~ 2021.2</h4>
          <h5>Letuin Inc.</h5>
          <h6>SW Business Unit Contents Lab Intern</h6>
          <p style={{ textAlign: "left" }}>
            <b>Main Responsibilities</b> <br></br>
            Analyzing customer data, planning and producing contents based on data analysis <br></br>
            <br></br>
            <b>Main Tasks / Achievements</b> <br></br>
            : Operated and managed customer community <br></br>
            : Analyzed customer reviews / community data <br></br>
            : Planned and produced contents based on customer data analysis <br></br>
            <br></br>
            <b>Achievements and Lessons Learned</b> <br></br>
            : Increased community users through customer data analysis (400 → 600) <br></br>
            : Cultivated practical knowledge and experience related to data analysis methodology, application methods, and application of analysis results
          </p>
        </div>
      </Card>
    </>
  );
}

export default Resume_Work;
